<template>
    <div>
    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>이미지 퀴즈 리스트(메인)</v-toolbar-title>
        <v-spacer/>
        <v-btn
            color="cyan"
            small
            fab
            @click="OnClick_CreateItem"
        >
            <v-icon 
            color= "white"
            >mdi-plus</v-icon>
        </v-btn>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[10, 50, -1]}"
        :headers="headers" 
        :items="quizbundle_list_main"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.pid}}</td>
            <td>{{row.item.category}}</td>
            <!-- <td>{{row.item.level}}</td> -->
          
            <td>{{row.item.regist_user}}</td>
            <td :style="{ color: row.item.quiz_count === 0 ? 'red' : 'black' }">
                {{ row.item.quiz_count }}
            </td>
            <!-- 추가되는 시작,종료일시 -->
            <td><img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+row.item.img_path" alt="Image"  style="width: 120px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"></td>
            <td>
            <span v-for="(char, index) in row.item.level.split('')" :key="index">
                <span :style="{ color: char === 'Y' ? 'blue' : 'red', fontWeight: 'bold' }">
                {{ char }}
                </span>
            </span>
            </td>
            <td>
                <v-btn width="120px"
                color="indigo"
                class='white--text'
                @click="OnClickEdit_Item(row.item.pid)">편집하기</v-btn>
            </td>
            <td>
                <v-btn 
                    width="120px" 
                    :color="row.item.dt_regist > row.item.dt_commit ? 'purple' : 'grey'"                     
                    :class="row.item.dt_regist > row.item.dt_commit ? 'white--text' : 'black--text'"
                    @click="OnCommitQuizBundle(row.item)"
                    >
                    커밋하기
                </v-btn>
            </td>
            <!-- <td>
                <v-switch
                    v-model="row.item.active"
                    inset       
                    @change="Save_Change_ActiveState(row.item)"
                ></v-switch>
            </td>
             -->
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue lighten-3'"
        dark
    >    
    <v-toolbar-title>이미지 퀴즈 리스트(가데이터)</v-toolbar-title>
        <v-spacer/>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[10, 50, -1]}"
        :headers="fake_headers" 
        :items="quizbundle_list_fake"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.pid}}</td>
            <td>{{row.item.category}}</td>        
            <td>{{row.item.regist_user}}</td>
            <!-- 추가되는 시작,종료일시 -->
            <td><img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+row.item.img_path" alt="Image"  style="width: 120px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"></td>
            <td>{{row.item.desc_text}}</td>
            <td>{{row.item.ref_pid}}</td>
            <td>
                <v-btn width="120px"
                color="indigo"
                class='white--text'
                @click="OnClickEdit_Item(row.item.pid)">편집하기</v-btn>
            </td>
            <!-- <td>
                <v-switch
                    v-model="row.item.active"
                    inset       
                    @change="Save_Change_ActiveState(row.item)"
                ></v-switch>
            </td>
             -->
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
            {{ dialog_title_text }}
        </v-card-title>

        <v-card-text>
            <v-text-field 
                label="퀴즈 타이틀"
                v-model="quiz_title_text" 
                outlined
                dense
            ></v-text-field>
            <v-text-field 
                label="운영자용     ex)동물 쉬운버전"
                v-model="quiz_title_text_comment" 
                outlined
                dense
            ></v-text-field>
            <v-text-field 
                label="퀴즈 타이틀 설명"
                v-model="quiz_title_desc_text" 
                outlined
                dense
            ></v-text-field>
            <v-row>
      <!-- 왼쪽: 이미지 업로드 입력 -->
      <v-col cols="12" md="6">
        <v-file-input
          label="배너이미지 (200*120)"
          accept="image/*"
          prepend-icon="mdi-image"
          outlined
          @change="handleFileChange"
        />
      </v-col>      
    </v-row>  
    <v-row>
        <v-col cols="12" md="6">
            <label class="text-subtitle-1 mb-2 d-block">난이도 선택 (1~5)</label>
            <v-row>
                <v-col cols="12" sm="6" md="12" v-for="item in quiz_level_list" :key="item.pid">
                <v-checkbox
                    :label="item.category"
                    :value="item.pid"
                    v-model="selected_quiz_level"
                    hide-details
                    dense
                ></v-checkbox>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
    <!-- <v-row>
        <v-col cols="12" md="6">
            <v-select
                v-model="selected_main_item_pid"
                :items="quizbundle_list_main"
                item-text="category"
                item-value="pid"
                label="퀴즈 선택"
                outlined
            ></v-select>
        </v-col>
    </v-row>     -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="CancelEdit"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="CreateQuizBundle"
          >
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>

</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
const { s3_upload , FileUpload_Async, FileUpload_JSON} = require("../../util/fileutil");
import { format, parseISO } from 'date-fns'
// const quiz_level_list = ref([
//         { pid: 1, category: '레벨 1' },
//         { pid: 2, category: '레벨 2' },
//         { pid: 3, category: '레벨 3' },
//         { pid: 4, category: '레벨 4' },
//         { pid: 5, category: '레벨 5' },
//         ]);

export default {
    name: 'UserList',

    data: () => ({
        dialog_title_text :'',
        dialog : false,
        loadingData:false,        
        create_date:'',
        quiz_title_text : '',
        quiz_title_desc_text: '',
        quiz_title_text_comment: '',
        imageFile : null, 
        headers: [            
            { text: '고유번호', value: 'pid' },
            { text: '타이틀', value: 'category' },  
            { text: '작성자', value: 'admin_user' },
            { text: '등록된 퀴즈', value: 'create_dt' },
            { text: '배너', value: 'img_path' },           
            { text: '활성정보', value: 'dt_create' },
            { text: '편집하기', value: 'edit' },
            { text: '커밋하기', value: 'commit' },
            // { text: '등록하기', value: 'dt_export' },
        ],
        fake_headers: [            
            { text: '고유번호', value: 'pid' },
            { text: '타이틀', value: 'category' },            
            { text: '작성자', value: 'admin_user' },
            { text: '배너', value: 'img_path' },           
            { text: '부가설명', value: 'dt_create' },        
            { text: '메인카테고리', value: 'main' },
            { text: '편집하기', value: 'main' },
            // { text: '등록하기', value: 'dt_export' },
        ],
        quizbundle_list_all:[
        ],
        quizbundle_list_main:[
        ],
        
        quizbundle_list_fake:[
        ],
        
        selected_main_item_pid:0,
        selected_editing_item:{},


        selected_quiz_level: [], // 체크된 pid 목록이 여기에 저장됨
        quiz_level_list: [
            { pid: 1, category: '레벨 1' },
            { pid: 2, category: '레벨 2' },
            { pid: 3, category: '레벨 3' },
            { pid: 4, category: '레벨 4' },
            { pid: 5, category: '레벨 5' },
        ]     
   
    }),

    created()
    {    
        this.LoadQuizBundleList();    
    },

    methods:{
        ...mapActions([
            'GET_QUIZLIST',
            'CREATE_QUIZ_BUNDLE',
            'GET_QUIZBUNDLE_LIST',
            'EDIT_QUIZ_BUNDLE',
            'DELETE_QUIZ_BUNDLE',
            'COMMIT_QUIZBUNDLE'
        ]),
        LoadQuizBundleList(){   
            //this.loadingData = true;
            // let packageName = this.$store.state.selected_game_package;
            this.quizbundle_list_all = [];
            this.GET_QUIZBUNDLE_LIST({}).then((body_data)=>{
                this.loadingData = false; 
                this.quizbundle_list_all = body_data.quizbundle_list;
                this.quizbundle_list_main = body_data.quizbundle_list.filter(item => item.ref_pid == 0);
                //this.quizbundle_list_fake = body_data.quizbundle_list.filter(item => item.ref_pid !== 0);
                console.log("퀴즈 번들리스트를 불러옵니다." );
                console.log(JSON.stringify(body_data));
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        ShowDialog_CreateBundle()
        {
            this.imageFile = null;
            this.dialog = false;    
        },
        async CreateQuizBundle()
        {
            console.log(this.selected_quiz_level);
            if(this.quiz_title_text == "" || this.quiz_title_text_comment == "")
            {
                alert("퀴즈 타이틀 텍스트를 입력해주세요");
                return;
            }

            if(this.imageFile == null){
                alert("이미지 등록이 필요합니다.");
                return;
            }   

            this.loadingData = true;
            this.dialog = false;    
            var newFileName = "snapquiz/quiz_img/banner/"+this.Utill_CreateNewImageName(this.imageFile.name);            
            let await_result = await FileUpload_Async(this.imageFile, newFileName);
            if(await_result)
            {
                this.loadingData = false;
                    let category = this.quiz_title_text;
                    let category_comment = this.quiz_title_text_comment;                    
                    let img_path = newFileName;              
                    let desc_text = this.quiz_title_desc_text;
                    let ref_pid = this.selected_main_item_pid;  
                    let level =  [1, 2, 3, 4, 5].map(pid => this.selected_quiz_level.includes(pid) ? 'Y' : 'X').join('');

                    this.CREATE_QUIZ_BUNDLE({category,category_comment ,  img_path, desc_text , ref_pid}).then((body_data)=>{
                        this.selected_main_item_pid = 0;
                        this.LoadQuizBundleList();
                    });
            }
        },
        handleFileChange(file)
        {
            this.imageFile = file;
        },


        Save_Change_ActiveState(item)
        {
            let packageName = this.$store.state.selected_game_package;
            let notice_title = item.TITLE;
            let notice_message = item.MESSAGE;
            let enable_yn = item.ENABLE_YN == "Y"?"N":"Y";                        
            let pid = item.PID;    

            this.loadingData = true; 
            this.SET_NOTICE_INFO({packageName, notice_title, notice_message, enable_yn, pid  }).then((body_data)=>{
                this.loadingData = false; 
                if(enable_yn == 'Y')
                {
                    alert('공지가 활성화 되었습니다.');
                }
                else{
                    alert('공지가 비활성화 되었습니다.');
                }
                this.LoadServerInfo();
                //alert("??");
                //this.quizbundle_list_all = body_data.notice_list;
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
            
        },
        IsItem_Active(item)
        {
            if(item.ENABLE_YN == 'Y')
                return true;
            else
                return false;
        },
        OnClickEdit_Item(item)
        {//아이템을 수정하려는 경우에 호출한다 
            // this.dialog_title_text = "퀴즈 타이틀";
            // // 변수의 속성을 미리 선언해두지 않고 들어온 데이터를 바로 넣어준 후 보여준다.
            // this.selected_editing_item = item;
            // this. appNoticeStartDateArr = this.selected_editing_item.START_DT.split(' ')
            // this.date = this.appNoticeStartDateArr[0]
            // this.time1 = this.appNoticeStartDateArr[1]
            // this. appNoticeEndDateArr = this.selected_editing_item.END_DT.split(' ')
            // this.date2 = this.appNoticeEndDateArr[0]
            // this.time2 = this.appNoticeEndDateArr[1]
            // this.dialog = true;
            this.$router.push({
                path: '/quizedit',
                query: {
                    pid: item,
                }
            });
        },

        OnClick_CreateItem()
        {
            this.dialog_title_text = "퀴즈 타이틀";
            // 디폴트 시간을 넣어준다.
            this.date = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd')
            this.time1 = "00:00:00"
            this.date2 = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd')
            this.time2 = "23:59:59"
            this.selected_editing_item = {}; 
            this.dialog = true;
        },

        CancelEdit()
        {
            this.dialog = false;    
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        Utill_CreateNewImageName(originalFileName)
        { // 확장자 추출
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
            // 랜덤 문자열 생성 (16자)
            const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
            // 새 파일 이름 생성
            return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
        },
     
        async OnCommitQuizBundle(item) {
            try {
                this.loadingData = true; // 데이터 로딩 시작
                console.log("OnCommitQuizBundle 시작");

                let bundle_pid = item.pid;

                // 퀴즈 리스트 가져오기
                const body_data = await this.GET_QUIZLIST({ bundle_pid });
                console.log("OnCommitQuizBundle 2");

                let selected_quiz_list_all = body_data.result;
                let newFileName = item.commit_path || `snapquiz/quiz_data/${this.Utill_CreateNewImageName('temp.json')}`;

                let quiz_data = selected_quiz_list_all;
                console.log("OnCommitQuizBundle 3");

                // JSON 업로드 시도
                const success = await FileUpload_JSON(quiz_data, newFileName);
                if (success) {
                    console.log("OnCommitQuizBundle 4");
                    
                    let pid = bundle_pid;        
                    let commit_path = newFileName;

                    // 퀴즈 번들 커밋
                    await this.COMMIT_QUIZBUNDLE({ pid, commit_path });
                    console.log("OnCommitQuizBundle 5");

                    this.LoadQuizBundleList();
                }
            } catch (err) {
                console.error("❌ OnCommitQuizBundle 오류 발생:", err);
            } finally {
                this.loadingData = false; // 예외 발생 여부와 관계없이 로딩 종료
            }
        }
    },
    computed: {
        isLive(){
            return config.isLive;
        },
        noticeStartDate () {
            return `${this.date} ${this.time1}`
        },
        noticeEndDate () {
            return `${this.date2} ${this.time2}`
        },
    },
    components:{
    },
    watch :{
            //'$store.state.selected_game_package': function() {
            //console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            //this.LoadServerInfo();
        //},
    }
};
</script>
